type ButtonColor = 'primary' | 'secondary' | 'success' | 'danger' | 'warning';

type ButtonVariant = 'default' | 'shaded';

export const ButtonDefaultVariants: {
    color: ButtonColor;
    variant: 'default';
    className: string[] | string;
}[] = [
    {
        color: 'primary',
        variant: 'default',
        className: [
            'bg-primary',
            'text-white',
            'shadow-primary/[8%]',
            'transition-all duration-200 hover:brightness-90 dark:hover:brightness-110',
        ],
    },
    {
        color: 'secondary',
        variant: 'default',
        className: [
            'bg-secondary',
            'text-grayscale-900',
            'border border-[#E9EBEE]/[8%] dark:border-[#20262D]',
            'shadow-[0px_0px_2px_rgba(18,40,44,0.12),0px_2px_4px_rgba(18,40,44,0.1)]',
            'transition-all duration-200 hover:brightness-[96%] dark:hover:brightness-[120%]',
        ],
    },
    {
        color: 'success',
        variant: 'default',
        className: ['bg-success-500', 'text-white', 'shadow-success-50'],
    },
    {
        color: 'danger',
        variant: 'default',
        className: ['bg-danger-500', 'text-white', 'shadow-danger-50'],
    },
    {
        color: 'warning',
        variant: 'default',
        className: ['bg-warning-500', 'text-white', 'shadow-warning-50'],
    },
];

export const ButtonShadedVariants: {
    color: ButtonColor;
    variant: 'shaded';
    className: string[] | string;
}[] = [
    {
        color: 'primary',
        variant: 'shaded',
        className: ['bg-primary/10', 'text-primary'],
    },
    {
        color: 'secondary',
        variant: 'shaded',
        className: ['bg-secondary-50', 'text-secondary-900'],
    },
    {
        color: 'success',
        variant: 'shaded',
        className: ['bg-success-50', 'text-success-500'],
    },
    {
        color: 'danger',
        variant: 'shaded',
        className: ['bg-danger-50', 'text-danger-500'],
    },
    {
        color: 'warning',
        variant: 'shaded',
        className: ['bg-warning-50', 'text-warning-500'],
    },
];

export const ButtonCompoundVariants: {
    color: ButtonColor;
    variant: ButtonVariant;
    className: string[] | string;
}[] = [...ButtonDefaultVariants, ...ButtonShadedVariants];
